import { Th, type ThProps } from '@frontend/components';

export type ResponseThProps = ThProps;

/**
 * Base table header cell component for Response.
 * Provides consistent styling for table headers in AI responses.
 */
export const ResponseTh = ({
  className,
  children,
  ...props
}: ResponseThProps) => {
  return (
    <Th className={className} fontWeight={'bold'} {...props}>
      {children}
    </Th>
  );
};
